var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "not-found" }, [
    _c("div", { staticClass: "not-found__text" }, [
      _c("div", { staticClass: "not-found__primary-text" }, [
        _vm._v(" " + _vm._s(_vm.title) + " ")
      ]),
      _c("div", { staticClass: "not-found__secondary-text" }, [
        _vm._v(" " + _vm._s(_vm.subtitle) + " ")
      ])
    ]),
    _c("img", {
      staticClass: "not-found__graphic",
      attrs: { src: _vm.notFound, alt: "Dead End graphic for page not found" }
    }),
    _c(
      "footer",
      { staticClass: "not-found__actions" },
      [
        _vm._t("action", function() {
          return [
            _c("ButtonClassic", {
              attrs: { variant: "primary", labelText: "Go to Dashboard" },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "dashboard" })
                }
              }
            })
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }